<style scoped>
.gray-bg {
  background-color: #F5F5F5 !important;
}
</style>

<template>
  <v-card flat :class="{ 'gray-bg': noBackground }">
    <slot name="title">
      <v-card-title v-if="title" class="subtitle-2 font-weight-medium pb-1">
        {{ title }}
      </v-card-title>
    </slot>
    <v-card-text class="pt-0 pb-3 black-text">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AnchorSidebarBaseCard',
  props: {
    title: String,
    noBackground: Boolean,
  },
};
</script>
